<template src="../templates/normal_fcont_190.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'
import { CONTENTS_INFO } from "@/common/contentsinfo"
import { mapState, mapGetters } from "vuex";

export default {
  name: 'app',
  data() {
    return {
      articleId: '190',
      app_root: process.env.VUE_APP_ROOT,

      // designpaper柄一覧 
      hStripesDesignIdList: ["01-01", "01-02", "01-03", "01-04", "01-05", "01-51", "01-52", "01-53", "01-54", "01-61", "01-62", "01-63"],
      dotDesignIdList: ["02-01", "02-02", "02-03", "02-04", "02-05", "02-51", "02-52", "06-01", "06-02", "06-03", "06-11", "06-12", "06-13", "06-14"],
      plaidDesignIdList: ["03-01", "03-02", "03-03", "03-04", "07-01", "07-02", "07-03", "07-04"],
      dStripesDesignIdList: ["04-01", "04-02", "04-03", "04-04", "04-51", "04-52", "04-53", "04-54", "04-55", "04-56"],
      kidsDesignIdList: ["33-01", "33-02", "33-11", "33-12", "33-21", "33-41", "33-42", "33-51", "33-52", "33-31", "33-32", "33-53", "33-54", "57-01",
        "57-02", "57-03", "57-11", "57-12", "57-13", "57-21", "57-22", "57-31", "57-32", "57-33", "57-34", "57-35", "57-36", "57-37", "57-38", "57-39"],
      floralDesignIdList: ["31-01", "31-02", "31-11", "31-21", "31-31", "31-41", "31-51", "31-61", "31-62", "31-63", "31-64", "31-65", "31-66", "31-67",
        "52-01", "52-02", "52-03", "52-04", "52-05", "52-11", "52-12", "59-11", "59-12", "59-13"],
      foodDesignIdList: ["60-01", "60-02", "60-05", "60-06", "60-07", "60-08", "60-09", "60-10", "60-11", "60-12", "60-13", "60-14", "60-15", "60-16",
        "60-17", "60-18", "60-19"],
      eventsDesignIdList: ["58-01", "58-02", "58-03", "58-04", "58-05", "58-06", "58-07", "58-08", "58-09", "58-10", "58-11", "58-21", "58-22", "58-23",
        "58-24", "58-25", "58-26", "58-27", "32-01", "32-11", "32-12", "32-13", "32-14", "32-15", "32-16", "32-17", "32-18", "32-19", "32-20"],
      tylesDesignIdList: ["12-01", "12-02", "12-03", "12-11", "12-12", "12-21", "12-22", "12-23", "12-24", "12-25"],
      jpDesignIdList: ["41-01", "41-02", "41-11", "41-12", "41-21", "41-22", "41-61", "41-62", "41-63", "41-64", "41-65", "41-66", "41-67", "41-68", "41-69",
        "41-70", "41-71", "41-72", "41-73", "54-01", "54-02", "54-11", "54-12", "54-21", "54-22"],
      spotDesignIdList: ["11-01", "11-02", "11-03", "11-04", "11-05"],
      geometryDesignIdList: ["13-01", "13-11", "13-12", "13-21", "13-22", "13-31", "13-32", "13-41", "13-42", "14-01", "14-11", "14-12", "14-13", "14-14", "05-01"],
      elegantDesignIdList: ["21-01", "21-02", "21-11", "21-21", "21-22", "21-31", "21-32", "21-41", "21-42", "21-43", "21-44", "21-45", "21-46", "21-47", "21-51",
        "21-52", "21-53", "21-54", "21-55", "21-56", "21-57", "21-58", "21-59", "21-60", "21-61"],
      basicDesignIdList: ["51-01", "51-02", "51-11", "51-12", "51-21", "51-22", "51-23", "51-31", "51-32", "51-41", "51-42", "51-43", "51-44", "51-45", "51-51",
        "51-52", "51-53", "51-61", "51-62", "51-63", "51-64"],
      nordicDesignIdList: ["53-01", "53-02", "53-03", "53-11", "53-12", "53-13", "53-21", "53-22", "53-23", "53-31", "53-32", "53-41", "53-42", "53-43", "53-44",
        "56-01", "56-02", "56-05", "56-06"],
      animalDesignIdList: ["55-01", "55-02", "55-03", "55-11", "55-12", "55-13", "55-14", "55-21", "55-22", "55-23", "55-24", "55-25", "55-31", "55-32"],
      environmentDesignIdList: ["61-01", "61-02", "61-03", "61-04", "59-33", "59-34"],
      otherDesignIdList: ["59-01", "59-02", "59-03", "59-14", "59-15", "59-21", "59-22", "59-23", "59-25", "59-31", "59-32", "59-35", "59-36", "59-37", "59-38", "59-39"]
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,ReleaseDateForArticle,InfoMachineTranslation,
    AppDownloadCreative,AppDownloadPhotoPlus
  },
  computed:{
    ...mapGetters(["isJpTemplate"]),
    ...mapState(["lg2","shouldDisplayAllDesignpaper"]),
    selectedTraditionalChinese: function () {
      return this.lg2 == "zh";
    },
    selectedThai: function () {
      return this.lg2 == "th";
    },
    isNotLocalChina: function () {
      return window.location.host != "support.epson.com.cn"
    },
  },
  methods: {
    clickLinkTile: function (designID) {
      const param = {
        articleIdToSamplePage: this.articleId,
        mediaSize: CONTENTS_INFO[this.articleId].media_size,
        mediaType: CONTENTS_INFO[this.articleId].media_type
      }
      this.$store.commit('setDesignPaperParameters', param)
      
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "designpaper_thumbnail",
        "custom_parameter2": designID
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/designpaper/' + designID,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    },
    clickShowMore: function () {
      this.$store.commit('setShouldDisplayAllDesignpaper', true)
    },
    trackGa4GoApp: function (appName, launchType) {
      this.$gtag.event("go_app", {
        "app_name": appName,
        "article_no": this.articleId,
        "print_type": launchType,
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['190-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['190-3']}
      ],
      link: [
        // 他記事へのリンクのスタイルをTopと合わせるため追加
        { rel: 'stylesheet', href: process.env.VUE_APP_ROOT + '/assets/common/css/fun_top.css' }
      ]
    };
  }
  
};
</script>
<style scoped>
div.dp-special h4 {
  font-size: 25px;
  font-weight: bold;
  border-bottom: 1px solid;
  width: 90%;
  margin-top: 1em;
}

div.dp-special img {
  padding-left: 0px;
  padding-right: 0px;
}

div.dp-title {
  text-align: center;
}

h3.dp-special {
  margin-top: 40px;
  font-size: 40px;
  font-weight: bold;
  position: relative;
  display: inline-block;
  padding: 0 55px;
}

h3.dp-special:before,
h3.dp-special:after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: black;
}

h3.dp-special:before {
  left: 0;
}

h3.dp-special:after {
  right: 0;
}

h3.dp-special-loc {
  margin-top: 0px;
  font-size: 22px;
  font-weight: bold;
  position: relative;
  display: inline-block;
  padding: 0 10px;
}

h3.dp-special-loc:before,
h3.dp-special-loc:after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
}

h3.dp-special-loc:before {
  left: 0;
}

h3.dp-special-loc:after {
  right: 0;
}

div.dp-category h4 {
  font-size: 25px;
  font-weight: bold;
  margin-top: 1em;
}

div.col-thumnail {
  padding-left: 10px;
  padding-right: 10px;

}

.dp-more-button {
  background-color: #FFFFFF;
  color: #000000;
  border: 1px solid #ddd;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}

.dp-more-button-icon {
  color: #c0c0c0;
}

/* 他記事へのリンク */
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex::before{ 
  display: none;
}

.flex .col {
  padding-bottom: 20px;
}

.func-search-recommend-link, .thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

.fade-enter-active {
  transition: opacity 0.6s;
}
.fade-enter {
  opacity: 0;
}

@media (max-width: 767px) {
  /* 他記事へのリンク */
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  h3.dp-special_ru , h3.dp-special_fi, h3.dp-special_uk {
    font-size: 30px;
  }
}

@media (max-width: 480px) {
  div.dp-special h4 {
    font-size: 21px;
  }

  h3.dp-special {
    margin-top: 30px;
    font-size: 30px;
  }

  h3.dp-special_ru , h3.dp-special_fi, h3.dp-special_uk {
    font-size: 25px;
    padding: 0 25px;
  }

  h3.dp-special_ru:before,h3.dp-special_ru:after,
  h3.dp-special_fi:before,h3.dp-special_fi:after,
  h3.dp-special_uk:before,h3.dp-special_uk:after {
    width: 20px;
  }

  div.dp-category h4 {
    font-size: 21px;
  }

}

</style>

